// extracted by mini-css-extract-plugin
export default {"productCard":"style_productCard__HCS9B"};